import { hasValue } from '../helpers';
import { isContactReceiver, isGroupReceiver } from '../typeguards';
export class MessageAccess {
    quote = false;
    ack = false;
    dec = false;
    delete = false;
    download = false;
    copy = false;
}
export class MessageService {
    static MAX_THUMBNAIL_SIZE = 350;
    receiverService;
    static $inject = ['ReceiverService'];
    constructor(receiverService) {
        this.receiverService = receiverService;
    }
    getAccess(message, receiver, capabilities, ownIdentity) {
        const access = new MessageAccess();
        if (message !== undefined) {
            const allowQuoteV1 = (message.type === 'text')
                || (message.type === 'location' && message.location?.description !== null && message.location.description.length > 0)
                || (hasValue(message.caption) && message.caption.length > 0);
            const allowQuoteV2 = capabilities.quotesV2;
            access.quote = receiver.type !== 'distributionList' && message.type !== 'voipStatus' && (allowQuoteV1 || allowQuoteV2);
            access.copy = allowQuoteV1;
            if (receiver !== undefined && message.temporaryId === undefined) {
                if (capabilities.emojiReactions) {
                    access.ack = true;
                    access.dec = true;
                }
                else {
                    const isIncomingMessage = message.isOutbox === false;
                    const allowReactionsForReceiver = isContactReceiver(receiver) ||
                        (isGroupReceiver(receiver) && capabilities.groupReactions);
                    const allowReactionsForType = message.type !== 'voipStatus';
                    if (isIncomingMessage && allowReactionsForReceiver && allowReactionsForType) {
                        access.ack = message.state !== 'user-ack' && !(message.reactions?.ack ?? []).includes(ownIdentity);
                        access.dec = message.state !== 'user-dec' && !(message.reactions?.dec ?? []).includes(ownIdentity);
                    }
                }
                switch (message.type) {
                    case 'image':
                    case 'video':
                    case 'audio':
                    case 'file':
                        access.download = true;
                        break;
                    default:
                        access.download = false;
                }
                access.delete = true;
            }
        }
        return access;
    }
    getQuoteText(message) {
        let quoteText = null;
        if (message !== null && message !== undefined) {
            switch (message.type) {
                case 'text':
                    quoteText = message.body;
                    break;
                case 'location':
                    quoteText = message.location.description;
                    break;
                case 'file':
                case 'image':
                    quoteText = message.caption;
                    break;
                default:
            }
        }
        return quoteText;
    }
    showStatusIcon(message, receiver) {
        if (message !== null && receiver !== null) {
            const messageState = message.state;
            switch (receiver.type) {
                case 'group':
                    if (message.isOutbox && (message.temporaryId === undefined || message.temporaryId === null)) {
                        return messageState === 'send-failed'
                            || messageState === 'sending'
                            || (messageState === 'pending' && message.type !== 'ballot');
                    }
                    return false;
                case 'distributionList':
                    return false;
                case 'contact':
                    if (!message.isOutbox) {
                        return messageState === 'user-ack'
                            || messageState === 'user-dec';
                    }
                    else if (this.receiverService.isBusinessContact(receiver)) {
                        return messageState === 'send-failed'
                            || messageState === 'sending'
                            || messageState === 'pending';
                    }
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }
    getPreviewThumbnail(uri, preview) {
        const image = new Image();
        image.src = uri;
        if (image.width > MessageService.MAX_THUMBNAIL_SIZE || image.height > MessageService.MAX_THUMBNAIL_SIZE) {
            const scale = Math.min(MessageService.MAX_THUMBNAIL_SIZE / image.width, MessageService.MAX_THUMBNAIL_SIZE / image.height);
            image.width = Math.round(scale * image.width);
            image.height = Math.round(scale * image.height);
        }
        return {
            previewDataUrl: uri,
            preview: preview,
            width: image.width,
            height: image.height,
        };
    }
    createTemporary(temporaryId, receiver, type, data, previewDataUrl) {
        const timestampS = Math.floor(Date.now() / 1000);
        const message = {
            type: type,
            id: undefined,
            date: timestampS,
            sortKey: undefined,
            partnerId: receiver.id,
            isOutbox: true,
            isStatus: false,
            state: 'pending',
            quote: data.quote,
            temporaryId: temporaryId,
        };
        switch (type) {
            case 'text':
                const textData = data;
                message.body = textData.text;
                break;
            case 'image': {
                const fileData = data;
                message.caption = fileData.caption;
                if (previewDataUrl !== undefined) {
                    message.thumbnail = this.getPreviewThumbnail(previewDataUrl, fileData.data);
                }
                break;
            }
            case 'video': {
                const fileData = data;
                message.video = {
                    duration: null,
                    size: fileData.size,
                };
                break;
            }
            case 'audio':
                break;
            case 'file': {
                const fileData = data;
                message.caption = fileData.caption;
                message.file = {
                    name: fileData.name,
                    size: fileData.size,
                    type: fileData.fileType,
                    inApp: false,
                };
                if (previewDataUrl !== undefined) {
                    message.thumbnail = this.getPreviewThumbnail(previewDataUrl, fileData.data);
                }
                break;
            }
            default:
                throw new Error(`Cannot create temporary message for type: ${type}`);
        }
        return message;
    }
    isSentOrSendingFailed(message) {
        switch (message.state) {
            case 'pending':
            case 'sending':
                return false;
            default:
                return true;
        }
    }
}
